import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52c08900"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "meal-input",
  class: "section-meal-input"
}
const _hoisted_2 = { class: "section-inner" }
const _hoisted_3 = { class: "preview-wrap" }
const _hoisted_4 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Text, {
        class: "section-copy",
        eyebrow: _ctx.$t('home.mealInput.eyebrow'),
        header: _ctx.formattedHeader,
        content: _ctx.formattedDesc,
        linkcont: _ctx.$t('home.mealInput.button'),
        link: "info",
        textAlign: "end"
      }, null, 8, ["eyebrow", "header", "content", "linkcont"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.previewImage)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.previewImage,
              alt: _ctx.$t('home.mealInput.imageAlt'),
              class: "preview-image"
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}